export default __webpack_public_path__ + "static/media/logoCompras.f984a0de.png";